import axios from "axios";

const isDev = process.env.NODE_ENV === "development";

export const axiosInstance = axios.create({
  baseURL: isDev
    ? "http://localhost:5600/"
    : "https://api.elifesavingmedicine.com/",
});

export const PF = isDev
  ? "http://localhost:5600/api/uploads/"
  : "https://api.elifesavingmedicine.com/api/uploads/";
export const PF_backup = isDev
  ? "http://localhost:5600/api/backup/"
  : "https://api.elifesavingmedicine.com/api/backup/";



const root = document.documentElement;
export const getSiteColorTheme = async () => {
  let color = "lightblue";
  const res = await axiosInstance.get("/api/web-settings/");
  if (res.data && res.data.siteColorTheme)
    color = res.data.siteColorTheme.toString();
  root.style.setProperty("--get-site-color-theme", color);
  return color;
};

getSiteColorTheme();
